<template>
  <Modal
    data-test="survey-into-modal"
    :has_parent="false"
    :is_cancel="false"
    :is_small="false"
    @actionPrimary="$emit('close')"
  >
    <template #title>
      <FallbackTranslation
        :record="survey_type"
        field="title"
      />
    </template>
    <template #content>
      <div
        v-if="!is_empty_description"
        class="p-2 text-xl"
      >
        <div
          data-test="survey-description"
          class="content"
          v-html="description_html"
        />
        <span
          v-if="description_html_fallback_language && $flipper.enabled($FT.MULTILINGUAL)"
          class="ml-1 text-xs text-gray-400"
          v-tooltip="description_html_fallback_tooltip"
          data-test="survey-description-fallback"
        >
          {{ description_html_fallback_language.toUpperCase() }}
        </span>
      </div>
    </template>
    <template #ButtonPrimary>
      {{ $t('survey.labels.lets_go') }}
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Modal from '@/app/shared_components/modals/TheModal.vue';
import FallbackTranslation from '@/app/shared_components/FallbackTranslation.vue';
import { mapGetters } from '@/store/lib/vue3helpers.js';

const props = defineProps({
  survey_type: { type: Object, required: true },
});

const { t } = useI18n();
const { translationOrFallbackFor } = mapGetters(['translationOrFallbackFor']);

const description_html_result = computed(() => translationOrFallbackFor.value(props.survey_type, 'description_html'));

const description_html = computed(() => description_html_result.value.fallback_translation);

const description_html_fallback_language = computed(() => description_html_result.value.fallback_language);

const description_html_fallback_tooltip = computed(() => {
  if (!description_html_fallback_language.value) return null;
  return t('constants.languages.fallback_info', {
    fallback_locale: t(`constants.languages.${description_html_fallback_language.value}`),
  });
});

const is_empty_description = computed(() => !description_html.value);
</script>
